import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SedsLoadersSpinnerComponent } from './seds-loaders-spinner.component';
import { SedsLoadersCoreModule } from '../../seds-loaders/seds-loaders-core/seds-loaders.module';

@NgModule({
  declarations: [SedsLoadersSpinnerComponent],
  imports: [CommonModule, SedsLoadersCoreModule],
  exports: [SedsLoadersSpinnerComponent],
})
export class SedsLoadersSpinnerModule {}
